import type { FrontendWidget } from '../types';
import { GradientSectionComponent } from './GradientSectionComponent';
import type { GradientSectionConfig, GradientSectionResolved } from './types';

export const gradientSectionWidget: FrontendWidget<
  GradientSectionConfig,
  GradientSectionResolved
> = {
  componentType: 'layouts.gradient-section',
  // 70.14: SlotRenderer adds no container — a section container — it paints its own area and contains its blocks.
  layout: 'self',
  displayName: 'Gradient Section',
  ComponentA: GradientSectionComponent,
  resolveSync: (config) => ({
    topColor: config.topColor ?? null,
    bottomColor: config.bottomColor,
    hideOnMobile: config.hideOnMobile ?? false,
    blocks: config.blocks ?? [],
  }),
};
